import { Link } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";
import PageShell from "@/components/PageShell";
import { useI18n } from "@/context/I18nContext";

/**
 * Shared shell for legal / support / FAQ pages.
 * Provides the app chrome (Nav + Footer via PageShell), premium hero,
 * and a back-to-Account breadcrumb.
 */
export default function LegalPageShell({ kicker, title, sub, icon, children, testId, updated }) {
    const { t } = useI18n();
    return (
        <PageShell
            testId={testId}
            maxWidth="max-w-3xl"
            kicker={kicker}
            title={title}
            sub={sub}
            actions={
                <Link
                    to="/account"
                    data-testid="legal-back-to-account"
                    className="inline-flex items-center gap-1.5 rounded-full border border-paw-line dark:border-white/15 hover:bg-paw-muted dark:hover:bg-white/5 px-4 py-2 text-sm font-medium text-paw-ink dark:text-paw-bone transition"
                >
                    <CaretLeft size={14} weight="bold" className="rtl:rotate-180" />
                    <span>{t("legal.back")}</span>
                </Link>
            }
        >
            {updated && (
                <p className="text-xs uppercase tracking-widest text-paw-ink2 dark:text-paw-bone/50 mb-4">
                    {t("legal.updated")} {updated}
                </p>
            )}
            {icon && (
                <div className="mb-6 inline-grid place-items-center w-14 h-14 rounded-2xl bg-paw-forest/10 dark:bg-paw-terra/15 text-paw-forest dark:text-paw-terra">
                    {icon}
                </div>
            )}
            <div className="prose-legal">
                {children}
            </div>
        </PageShell>
    );
}
